import React from "react";
import { Container, Box, Typography, Divider } from "@mui/material";
import { Link } from "react-router-dom";

export default function MaguyFlorestal() {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4, mb: 6 }}>

        {/* Lien retour */}
         <Link
           to="/"
           style={{
                display: "inline-block",
                background: "#FFD84D",
                color: "#0B2C5F",
                padding: "8px 16px",
                borderRadius: "6px",
                fontWeight: "600",
                textDecoration: "none",
                marginBottom: "20px"
            }}
     >
          ← Retour à l'accueil
        </Link>

        {/* En-tête profil */}
        <Box sx={{ textAlign: "center", mt: 3, mb: 5 }}>
          <img
            src="/gouvernance/directrice-etudes.jpeg"
            alt="Maguy Florestal"
            style={{
              width: "240px",
              borderRadius: "14px",
              marginBottom: "20px",
            }}
          />

          <Typography variant="h4" sx={{ fontWeight: 900, color: "#0B2C5F" }}>
            Maguy Florestal
          </Typography>

          <Typography sx={{ color: "text.secondary", mt: 1 }}>
            Directrice des études – École de la Magistrature
          </Typography>

          <Typography sx={{ color: "text.secondary" }}>
            Juge à la Cour de cassation
          </Typography>
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Présentation
        </Typography>

        <Typography paragraph>
          Magistrate de carrière, spécialisée en droit des nouvelles technologies
          de l’information et de la communication (NTIC), Madame Maguy Florestal
          est diplômée de l’École de la Magistrature haïtienne. Elle est
          licenciée en droit et a également suivi une formation universitaire en
          psychologie à la Faculté d’Ethnologie de l’Université d’État d’Haïti.
        </Typography>

        <Typography paragraph>
          Elle a poursuivi des études de deuxième cycle à l’Université de
          Montréal en droit des nouvelles technologies de l’information et de la
          communication, où elle a complété le programme académique de maîtrise.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Formation académique et perfectionnement
        </Typography>

        <Typography paragraph>
          Sa formation professionnelle s’est enrichie de plusieurs stages à
          l’École Nationale de la Magistrature (France), ainsi que d’une
          spécialisation de courte durée en ingénierie pédagogique à l’École
          nationale de la magistrature de Bordeaux.
        </Typography>

        <Typography paragraph>
          Elle a également suivi diverses formations de formateurs. Par ailleurs,
          elle a étudié les systèmes judiciaires coréen et américain,
          respectivement en Corée du Sud et aux États-Unis d’Amérique,
          formations sanctionnées par des certificats.
        </Typography>

        <Typography paragraph>
          Elle est titulaire d’un certificat en gouvernance et développement
          institutionnel : défis actuels pour Haïti, délivré conjointement par
          l’Université Laval et l’Université d’État d’Haïti, ainsi que d’une
          spécialisation en genre obtenue auprès du Centre international de
          formation de l’OIT (ITC/ILO) à Turin, en Italie.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Parcours professionnel
        </Typography>

        <Typography paragraph>
          Sur le plan professionnel, elle est actuellement juge à la Cour de
          cassation et Directrice des études à l’École de la Magistrature. Elle
          est également professeure d’organisation judiciaire à l’Université
          d’État d’Haïti.
        </Typography>

        <Typography paragraph>
          Au cours de sa carrière, elle a occupé successivement les fonctions de
          substitut du commissaire du gouvernement, juge pour enfants, juge,
          juge d’instruction près le Tribunal de première instance de
          Port-au-Prince, puis juge à la Cour d’appel de Port-au-Prince, de
          juin 1998 à mars 2023.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Affiliations et engagements
        </Typography>

        <Typography paragraph>
          Elle est membre active de plusieurs associations professionnelles,
          notamment membre et ancienne présidente de l’Association des anciens
          boursiers de la Corée du Sud, membre du Chapitre haïtien de
          l’Association internationale des femmes juges (CHAIFEJ), ainsi que
          membre fondatrice et vice-présidente de l’Association nationale des
          magistrats haïtiens (ANAMAH).
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Publications
        </Typography>

        <Typography paragraph>
          Auteure de publications juridiques, elle a notamment publié un
          <strong> Manuel de formation sur la problématique de genre </strong>
          (novembre 2020) et un essai intitulé
          <strong> Le Magistrat et son Éthique </strong>
          (septembre 2015).
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Distinctions
        </Typography>

        <Typography paragraph>
          Son engagement et sa contribution à la magistrature et à la promotion
          des droits des femmes ont été reconnus à travers plusieurs
          distinctions nationales, décernées notamment par le Chapitre haïtien
          de l’Association internationale des femmes juges, SOS Liberté, la
          Chambre des députés, le Conseil supérieur du pouvoir judiciaire et le
          Ministère à la Condition féminine et aux droits des femmes.
        </Typography>
      </Box>
    </Container>
  );
}